var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMarkSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.93455 0 0 4.93455 0 11C0 17.0654 4.93455 22 11 22C17.0654 22 22 17.0654 22 11C22 4.93455 17.0654 0 11 0ZM17.355 9.17286L10.5366 15.9913C10.2978 16.2301 9.97401 16.3642 9.63637 16.3642C9.29874 16.3642 8.97493 16.2301 8.73617 15.9913L5.32685 12.5821C4.82965 12.085 4.82965 11.2788 5.32685 10.7816C5.82397 10.2845 6.63013 10.2845 7.12734 10.7816L9.63637 13.2906L15.5546 7.37238C16.0517 6.87525 16.8578 6.87525 17.355 7.37238C17.8522 7.8695 17.8522 8.67566 17.355 9.17286Z",
    fill: "#302D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkSvg);
export default __webpack_public_path__ + "static/media/CheckMarkSVG.181ca355e8d550a06e62fca370d5fd0f.svg";
export { ForwardRef as ReactComponent };